import axios from "axios";
import API from "./apiInstance";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";

export const getProfileData = () => {
  const response = API.get(`/users/profile`);
  return response;
};

export const fetchPractices = async () => {
  try {
    const response = await axios.get(
      `${Config.apiServerUrl}/all/practice`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const fetchLocations = async () => {
  try {
    const response = await axios.get(
      `${Config.apiServerUrl}/all/location`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const updateUserTour = async (formData) => {
  try {
    const response = await axios.put(`${Config.apiServerUrl}/users/update-tour-needed`, formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateUserProfile = (data) => {
  try {
    const response = axios.post(
      `${Config.apiServerUrl}/users/profile/update`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const checkUnityEhrCredentials = async (data) => {
  try {
    const response = await axios.post(
      `${Config.apiServerUrl}/ehr/check_unity_ehr_credentials`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};
